import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetExpensesQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["expenses", params],
    queryFn: () => api.get(API_ROUTES.GET_EXPENSES, { params }),
    enabled,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useCreateExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post(API_ROUTES.CREATE_EXPENSE, data),
    onSuccess: () => {
      showToast("success", "Expense created");
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
    },
    onError: () => showToast("error", "Failed to create expense"),
  });
};

export const useUpdateExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) =>
      api.put(`${API_ROUTES.UPDATE_EXPENSE}/${id}`, data),
    onSuccess: () => {
      showToast("success", "Expense updated");
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
    },
    onError: () => showToast("error", "Failed to update expense"),
  });
};

export const useDeleteExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      api.delete(`${API_ROUTES.DELETE_EXPENSE}/${id}`),
    onSuccess: () => {
      showToast("success", "Expense deleted");
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
    },
    onError: () => showToast("error", "Failed to delete expense"),
  });
};
